import { branding_theme, font_config } from './branding';
import { StyleConfigInterface } from './stylesInterface';

export const getStyleConfig = (config: any, fontConfig: any) => {
  const {
    primary,
    background,
    neutral_900,
    neutral_800,
    neutral_500,
    neutral_400,
    neutral_300,
    neutral_white,
    alert_error,
    neutral_alpha_40,
    neutral_alpha_60,
    neutral_alpha_80,
    transparent,
  } = config || {};

  const { primary_font, secondary_font } = fontConfig || {};

  return {
    navbarBackground: { backgroundColor: transparent },
    bodyBackgroundColor: { backgroundColor: background },
    signInButton: { backgroundColor: neutral_900 },
    signUpButton: { backgroundColor: primary },
    signInButtonText: { color: neutral_white },
    signUpButtonText: { color: neutral_white },
    navbarText: { color: neutral_white },
    carouselPaginationInactive: { backgroundColor: neutral_500 },
    carouselPaginationActive: { backgroundColor: primary },
    seeMoreText: { color: primary },
    seeMoreIcon: { color: primary },
    videostripTitle: { color: neutral_white },
    videoDetailsTitle: { color: neutral_white },
    videoDetailsDescription: { color: neutral_white },
    genresChipContainer: { backgroundColor: neutral_900 },
    genresChipContainerText: { color: neutral_white },
    startWatchingButtonBackground: { backgroundColor: primary },
    modalBackgroundColors: { backgroundColor: neutral_900 },
    signInText: { color: neutral_white },
    emailIdText: { color: neutral_white },
    bottomSubText: { color: neutral_white },
    signOrSignUpLinkHighlight: { color: primary },
    primaryThemeButtonText: { color: neutral_white },
    globalFontFamily: { fontFamily: primary_font },
    secondaryFontFamily: { fontFamily: secondary_font },
    favoriteButtonBackground: { backgroundColor: neutral_900 },
    favoriteAndShareButtonText: { color: neutral_white },
    leftSideBarText: { color: neutral_white },
    genre: { backgroundColor: neutral_800 },
    secondaryText: { color: neutral_300 },
    primaryTextColor: { color: neutral_white },
    neutral400: { color: neutral_400 },
    live: { backgroundColor: alert_error },
    progress: { backgroundColor: primary },
    divider: { borderColor: neutral_800, borderWidth: 0.2 },
    footerText: { color: neutral_alpha_40 },
    deleteText: { color: primary },
    startWatchingProgress: { backgroundColor: neutral_white },
    startWatchingButtonUnProgress: { backgroundColor: neutral_900 },
    unprogress: { backgroundColor: neutral_400 },
    ternaryButton: { backgroundColor: neutral_800 },
    helpText: { color: neutral_alpha_80 },
    helpValueText: { color: primary },
    epgViewedStatus: { backgroundColor: neutral_alpha_60 },
    errorColor: { color: alert_error },
    errorBorder: { borderColor: alert_error },
  };
};

export const globalStyles: StyleConfigInterface = getStyleConfig(branding_theme, font_config);
